package com.vamvisions.main.components

import androidx.compose.runtime.Composable
import com.vamvisions.main.theme.AppStyleSheet
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

/**
 * A titled region of a page. [id] must be unique on the page; the heading gets `$id-title`. An [eyebrow] is a small
 * label above the title; the section stays named by the title alone. [attrs] adds to the section element, for
 * example a reveal on scroll.
 */
@Composable
fun Section(
    id: String,
    title: String,
    eyebrow: String? = null,
    attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
    content: @Composable () -> Unit,
) {
    val titleId = "$id-title"
    Section(attrs = {
        id(id)
        classes(AppStyleSheet.section)
        attr("aria-labelledby", titleId)
        attrs?.invoke(this)
    }) {
        if (eyebrow == null) {
            SectionTitle(titleId, title)
        } else {
            Div(attrs = { classes(AppStyleSheet.sectionHeading) }) {
                P(attrs = { classes(AppStyleSheet.sectionEyebrow) }) { Text(eyebrow) }
                SectionTitle(titleId, title)
            }
        }
        content()
    }
}

@Composable
private fun SectionTitle(id: String, title: String) {
    H2(attrs = {
        id(id)
        classes(AppStyleSheet.sectionTitle)
    }) {
        Text(title)
    }
}
